import _ from 'lodash'
import { wbsItemAdditionalPropertyService } from '../../../../../../../../domain/entity/WbsItemAdditionalPropertyEntity'
import {
  WbsItemAdditionalPropertyLayoutEntity,
  PropertyLayout,
} from '../../../../../../../../domain/entity/WbsItemAdditionalPropertyLayoutEntity'
import { GetEntitySearchReferenceEntityRepository } from '../../../../../../../hooks/useWbsItemAdditionalProperties'
import {
  DecomposedTableDef,
  TableHeaderWithLayout,
  TableCellWithLayout,
} from '../../model'
import { FunctionPropertyConfigurationMapByExternalId } from '../../../../../hooks/functionPropertyConfiguration'
import {
  overwriteTableCellWithConfig,
  overwriteTableHeaderWithConfig,
} from '../function-property-configuration'
import { toCellDef } from './toCellDef'
import { toTableHeaderDef } from './toTableHeaderDef'

export const wbsItemAdditionalPropertyToTableDef = (
  wbsItemAdditionalProperties:
    | WbsItemAdditionalPropertyLayoutEntity
    | undefined,
  configMapByExternalId: FunctionPropertyConfigurationMapByExternalId,
  getEntitySearchReferenceEntityRepository: GetEntitySearchReferenceEntityRepository,
  baseTableIndex: number
): DecomposedTableDef => {
  if (!wbsItemAdditionalProperties) {
    return {
      tableHeaders: [],
      cells: [],
    }
  }

  const tableHeaders: TableHeaderWithLayout[] = []
  const cells: TableCellWithLayout[] = []
  wbsItemAdditionalProperties.groupHeaderLayouts.forEach(
    ({ groupHeader, propertyLayouts }, tableIndex) => {
      const tableHeaderDef = {
        tableHeader: toTableHeaderDef(groupHeader),
        tableIndex: baseTableIndex + tableIndex,
        hidden: false,
      }
      const groupHeaderId =
        groupHeader.entityExtensionExternalId || groupHeader.uuid
      if (groupHeaderId in configMapByExternalId) {
        overwriteTableHeaderWithConfig(
          tableHeaderDef,
          configMapByExternalId[groupHeaderId]
        )
      }
      tableHeaders.push(tableHeaderDef)

      const propertyLayoutChunks: PropertyLayout[][] = _.chunk(
        propertyLayouts,
        2
      )
      propertyLayoutChunks.forEach((propertyLayoutChunk, rowIndex) => {
        propertyLayoutChunk.forEach(
          ({ wbsItemAdditionalProperty }, columnIndex) => {
            const cellDef = {
              cell: toCellDef(
                wbsItemAdditionalProperty,
                getEntitySearchReferenceEntityRepository
              ),
              tableHeaderExternalId:
                groupHeader.entityExtensionExternalId || groupHeader.uuid,
              rowIndex,
              columnIndex,
              hidden: false,
            }
            const additionalPropertyId =
              wbsItemAdditionalPropertyService.getAdditionalPropertyExternalId(
                wbsItemAdditionalProperty
              )
            if (additionalPropertyId in configMapByExternalId) {
              overwriteTableCellWithConfig(
                cellDef,
                configMapByExternalId[additionalPropertyId]
              )
            }
            cells.push(cellDef)
          }
        )
      })
    }
  )

  return {
    tableHeaders,
    cells,
  }
}
